import React, { memo, useCallback } from 'react';
import TabComp from '@components/tabs';
import { NoData } from '@components';
import AcquisitionHistoryTable from './acquisitionHistoryTable';

// import '@style/modules/analysis/analysisRight.scss';
import '../../../../styles/modules/analysis/analysisRight.scss';
import { getValueFromSearchParam, setURLSearchParam } from '@utils/history';
import { useHistory } from 'react-router-dom';

const AcquisitionHistory = ({ data, resourceId, isSingleCompany }) => {
  // const { acquisitionHistory, companyName } = data[resourceId][0];
  const tabsSrc = data.ah.map((e) => ({
    companyName: e.companyName,
    acquisitionHistory: e.acquisitionHistory,
    isManualInput: e.isManualInput,
  }));

  const { tab: defaultValue } = getValueFromSearchParam('tab');

  const history = useHistory();
  const onTabChange = useCallback((e, tab) => {
    if (tab) {
      setURLSearchParam(history, { tab });
    }
  }, []);

  return (
    <div className="analysis-right-wrapper">
      <div className="title title-acquisition-history">Acquisition History</div>
      <TabComp
        isSingleCompany={isSingleCompany}
        defaultValue={defaultValue}
        onChange={onTabChange}
        tabs={tabsSrc.map((tab) => ({
          label: tab.companyName || '-',
          children: tab.isManualInput ? (
            <NoData />
          ) : (
            <AcquisitionHistoryTable
              acquisitionHistory={tab.acquisitionHistory}
            />
          ),
        }))}
      />
    </div>
  );
};

export default memo(AcquisitionHistory);
